<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "../../composables/I18n";
import { useIdGen } from "mu-vue-utils/Composables/idGen";
import { authTL } from "../../generated/tl";
import { formatCommonResultErrors } from "../../services/tlError";
import FormPair from "../forms/FormPair.vue";
import FormInput from "../forms/FormInput.vue";
import { useTheme } from "../../composables/useTheme";

const { t } = useI18n();
const { logoUrl } = useTheme();
const ig = useIdGen();

const emit = defineEmits<{ loggedIn: [] }>();

const usernameOrEmail = ref('');
const password = ref('');
const error = ref('');
const submitting = ref(false);

const submit = async () => {
  submitting.value = true;
  error.value = '';
  try {
    const result = await authTL.login(usernameOrEmail.value, password.value);
    if (result.status === 'error') {
      error.value = formatCommonResultErrors(result.errors);
      return;
    }
    emit('loggedIn');
  } finally {
    submitting.value = false;
  }
};
</script>

<template>
  <div class="d-flex justify-content-center mt-5">
    <form class="col-12 col-sm-6 col-md-4" @submit.prevent="submit">
      <img v-if="logoUrl" :src="logoUrl" alt="Flopi" class="auth-logo">
      <h4 class="mb-3">{{ t('auth.loginTitle') }}</h4>
      <div v-if="error" class="alert alert-danger">{{ error }}</div>
      <FormPair :label="t('auth.usernameOrEmail')" layout="vertical" :is-required="true" :for-id="ig('usernameOrEmail')">
        <FormInput :id="ig('usernameOrEmail')" v-model="usernameOrEmail" />
      </FormPair>
      <FormPair :label="t('auth.password')" layout="vertical" :is-required="true" :for-id="ig('password')">
        <FormInput type="password" :id="ig('password')" v-model="password" />
      </FormPair>
      <button type="submit" class="btn btn-primary w-100 mt-2" :disabled="submitting">{{ t('auth.login') }}</button>
    </form>
  </div>
</template>

<style scoped>
</style>
